import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { ArrowRight } from "components/icons/ArrowRight";
import ReactCountryFlag from "react-country-flag";
import { Entity } from "types/Models/entity";
import { ModalProps } from "types/utils/modal";

export const ActionItemEntitySelector = ({
  isOpen,
  close,
  entityList,
  context,
  setSelectedEntity,
}: ModalProps & {
  entityList: Entity[];
  context: string;
  setSelectedEntity: (entityId: string) => void;
}) => {
  return (
    <Modal.Root open={isOpen} onOpenChange={close}>
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>Go to {context}</Modal.Title>
          <Modal.Close />
        </Modal.Header>
        <Modal.Body>
          <div className="t-text-text-body-sm t-text-text-30">
            Choose the entity to continue to the {context}
          </div>
          <div className="t-flex t-flex-col t-gap-4 t-mt-4">
            {entityList.map((entity) => (
              <div
                className="t-flex t-items-center t-justify-between t-p-4 t-border t-border-solid t-border-neutral-10 t-rounded-lg"
                key={entity.uuid}
              >
                <div className="t-flex t-items-center t-gap-4">
                  <ReactCountryFlag
                    countryCode={entity.country_code}
                    svg
                    title={entity.country}
                    style={{
                      width: "1.5em",
                      height: "1.5em",
                    }}
                    className="t-rounded"
                  />
                  <div>{entity.name}</div>
                </div>
                <Button onClick={() => setSelectedEntity(entity.uuid)}>
                  Select{" "}
                  <div className="t-text-text-30">
                    <ArrowRight color="currentColor" />
                  </div>
                </Button>
              </div>
            ))}
          </div>
        </Modal.Body>
        <Modal.FooterButtonGroup>
          <div className="t-h-6"></div>
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );
};
